function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import * as React from 'react';
import { ButtonReact } from 'common/components/button';
import { ButtonSize, ButtonTheme, ButtonType } from 'common/components/button/constants';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { DisplaySize, Placement } from 'common/components/tooltip/types';
import { generateCountCalculationMenuOptions, getSelectedCountBy, isAdvancedValueCalculation } from 'common/query-builder/query-block/count-menu/util';
import { getMultiAttributionFromEntry } from 'common/query-builder/query-builder/util';
import { CountUsersOnceState } from 'common/report/constants';
import { COUNT_USERS_ONCE_TYPE, MetricType } from 'common/types/reports/bookmark';
import { isScdPropertyName } from 'common/report/util/properties';
import { preventTracking } from 'common/util/dom';
import { useTranslation } from 'common/i18n/hooks';
import { FeatureRolloutName } from 'common/report/util/feature-sampling';
import { useFeatureRollout } from 'common/hooks/useFeatureRollout';
import { RECURRING_REVENUE_CHANGE } from 'common/query-builder/query-block/properties-menu/constants';
import { CountQueryBlock } from 'common/query-builder/query-block/count-menu/count-query-block';
import { Calculation, CalculationTypes, CountBy, InsightsCountType, isEventBasedEntry, isQueryUserEntry, isUserBasedEntry, MetricEntryMeasurement } from 'common/query-builder/query-entry-section/types';
import { getQueryEntryUpdateFromCalculation, getSelectedCalculation, getSelectedCalculationLabel, isProfileScdAggregation } from 'common/query-builder/query-entry-section/util';
import { QueryEntrySectionTrackingEvent } from 'common/query-builder/query-entry-section/tracking';
import { MetricEntry } from 'common/query-builder/query-entry-section/types';
import type { RowProps } from '../types/catalog';
export type MetricCountBySelectionProps = RowProps & {
  onMetricCountBySelected?: (countBy: CountBy) => void;
};

/**
 * Provides the selection menu for changing a Metric's measurement config
 */
export function MetricCountBySelection(props: MetricCountBySelectionProps) {
  var _behavior$dataGroupId;
  const isRevenueEnabled = useFeatureRollout(FeatureRolloutName.Revenue);
  const {
    t,
    print
  } = useTranslation();
  const {
    behavior,
    measurement
  } = props.entry;
  const dateUnit = props.sectionProps.dateUnit;
  const plotStyle = props.sectionProps.plotStyle;
  const isUserBased = isUserBasedEntry(props.entry);
  const dataGroupId = (_behavior$dataGroupId = behavior.dataGroupId) !== null && _behavior$dataGroupId !== void 0 ? _behavior$dataGroupId : measurement.dataGroupId;
  const selectedCalculation = getSelectedCalculation(measurement);
  const selectedCalculationLabel = getSelectedCalculationLabel(selectedCalculation, dateUnit);
  const calculationSelectorOptions = isUserBased && !isProfileScdAggregation(props.entry) ? [] : generateCountCalculationMenuOptions({
    selectedPlotStyle: plotStyle,
    selectedCalculation,
    selectedDateUnit: dateUnit
  });
  const handleMeasurementUpdate = (updatedMeasurement: Partial<MetricEntryMeasurement>) => {
    var _entry$measurement$ro;
    const entry: MetricEntry = _objectSpread(_objectSpread({}, props.entry), {}, {
      measurement: _objectSpread(_objectSpread({}, props.entry.measurement), updatedMeasurement)
    });
    props.updateEntry(entry);
    props.dispatchTrack(QueryEntrySectionTrackingEvent.SelectNumericAggregator, _objectSpread({
      /** @todo(metrics) tracking */
      // ...props.getEntryTrackingProps(entry),
      Aggregator: entry.measurement.aggregationOperator,
      'Per-user aggregator': entry.measurement.aggregationOperatorPerUser,
      'Rolling window size': (_entry$measurement$ro = entry.measurement.rolling) === null || _entry$measurement$ro === void 0 ? void 0 : _entry$measurement$ro.rollingWindowSize,
      Cumulative: Boolean(entry.measurement.cumulative)
    }, entry.measurement.property && {
      'Property name': entry.measurement.property.label,
      'Property data type': "type" in entry.measurement.property && entry.measurement.property.type
    }));
  };
  return <>
      <CountQueryBlock className='subitem-style' elref='countBlock'
    // TODO: Cleaner way to do this?
    metricType={props.entry.behavior.type === MetricType.Simple ? MetricType.Event : props.entry.behavior.type} advancedMenuSections={calculationSelectorOptions} allDataGroups={props.sectionProps.dataGroupsEnabled} countUsersOnceState={getMultiAttributionFromEntry(props.entry) ? CountUsersOnceState.Required : props.sectionProps.countUsersOnceState} chartType={props.sectionProps.chartType} dataGroupId={props.sectionProps.dataGroupId || dataGroupId} dataGroups={props.dataGroups} dateRange={props.sectionProps.dateRange as any} dateUnit={props.sectionProps.dateUnit} enableWorkspaceFilterRestrictions={props.sectionProps.enableWorkspaceFilterRestrictions}
    /** @todo(metrics) extract event names from behaviors */ eventNames={[]} includeCustomProperties={props.sectionProps.includeCustomProperties} showBorrowedProperties={props.sectionProps.showBorrowedProperties} hideEvents={!isEventBasedEntry(props.entry)} otherAggregationOptions={[...(props.sectionProps.otherAggregationOptions || []), isRevenueEnabled && isUserBased && RECURRING_REVENUE_CHANGE].filter(Boolean)} hideEditControls={props.sectionProps.hideEditControls} projectHasPeople={props.sectionProps.projectHasPeople} projectId={props.sectionProps.projectId} queryOrigin={props.sectionProps.queryOrigin} readonly={behavior.type === MetricType.Cohort} selected={getSelectedCountBy(props.entry)} trackName={props.sectionProps.trackName} userId={props.sectionProps.userId} workspaceId={props.sectionProps.workspaceId} onSelect={props.onMetricCountBySelected ? props.onMetricCountBySelected : countBy => {
      const {
        aggregationOperatorPerUser = null,
        property = null,
        advancedMenuValue = null
      } = countBy;
      let {
        rolling,
        cumulative,
        countUsersOnceType
      } = props.entry.measurement;
      if (advancedMenuValue && isAdvancedValueCalculation(advancedMenuValue)) {
        // commited from advanced menu (changed calculation type)
        const calculationType = advancedMenuValue.calculationType;
        if (calculationType === CalculationTypes.Rolling) {
          rolling = {
            rollingWindowSize: advancedMenuValue.rollingWindowSize
          };
          cumulative = false;
        } else if (calculationType === CalculationTypes.Cumulative) {
          rolling = null;
          cumulative = true;
        }
      }
      if (Object.values(COUNT_USERS_ONCE_TYPE).some(type => type === countBy.countUsersOnceType)) {
        countUsersOnceType = countBy.countUsersOnceType;
      }
      if (countBy.countType !== InsightsCountType.UniqueUsers || countUsersOnceType === COUNT_USERS_ONCE_TYPE.MULTIPLE) {
        countUsersOnceType = null;
      }
      if (isQueryUserEntry(props.entry) && property && !(property.value === RECURRING_REVENUE_CHANGE.value || isScdPropertyName(property.value))) {
        rolling = null;
        cumulative = false;
      }
      handleMeasurementUpdate({
        aggregationOperator: countBy.aggregationOperator,
        aggregationOperatorPerUser,
        property,
        rolling,
        cumulative: Boolean(cumulative),
        countUsersOnceType
      });
    }} onTrack={preventTracking} data-sentry-element="CountQueryBlock" data-sentry-source-file="metric-count-by-menu.tsx" />
      {selectedCalculation.calculationType && <div className='calculation-selector'>
          <SelectReact key='calculation-selector' elref='calculationSelector' label={print(selectedCalculationLabel)} disableSearch menuWidth={180} trackName={props.sectionProps.trackName} theme={SelectTheme.Tertiary} disableTooltip onChange={(ev: CustomEvent) => {
        handleMeasurementUpdate(getQueryEntryUpdateFromCalculation({
          originalCalculation: props.entry.measurement,
          calculation: ev.detail.item.value as Calculation
        }));
      }} sections={calculationSelectorOptions} />
          <ButtonReact className='remove-button' theme={ButtonTheme.Tertiary} size={ButtonSize.Inline} type={ButtonType.Destructive} tooltip={{
        placement: Placement.RightCenter,
        size: DisplaySize.Small,
        text: t("query-builder.actions.remove")
      }} icon='x' onClick={() => {
        handleMeasurementUpdate({
          rolling: null,
          cumulative: null
        });
      }} />
        </div>}
    </>;
}